import React from 'react';

import { images } from '../../constants';
import { SubHeading } from '../../components';

const FindUs = () => (
  <div className="app__bg">
      <div className="app__wrapper section__padding" id="contact" style={{width:'90%'}}>
        <div className="app__wrapper_info">
          <SubHeading title="Contact" />
          <h1 className="headtext__italiana" style={{ marginBottom: '2rem' }}>Find Us</h1>
          <div className="app__wrapper-content">
            <p className="p__opensans">20, Hageoma 7-gil, Wansan-gu, Jeonju-si, Jeollabuk-do, Republic of Korea</p>
            <p className="p__italiana" style={{ color: '#FAE481', margin: '2rem 0'}}>Opening Hours</p>
            <p className="p__opensans">Mon - Fri: 10:00 am - 06:00 pm</p>
            <p className="p__opensans">Sat - Sun: Closed</p>
          </div>
          <button type='button' className="custom__button" style={{ marginTop: '2rem'}}>Visit Us</button>
        </div>

        <div className="app__wrapper_img">
          <img src={images.findus} alt="findus" />
        </div>
    </div>
  </div>
);

export default FindUs;
